import { first } from '@amcharts/amcharts5/.internal/core/util/Array';
import { from, timestamp } from 'rxjs';

export const locale = {
	lang: 'it',
	data: {
		home: {
			title: 'My Guglielmo Dashboard v2',
		},
		overview: {
			title: 'Overview',
			device: 'Dispositivi',
			usage: 'Utilizzo',
			users: 'Utenti',
			device_at_day: 'Al giorno',
			average_usage: 'Durata media connessione',
			total_traffic_dow: 'Traffico totale',
			total_traffic_upload_download: 'Traffico totale',
			average_traffic_upload_download: 'Traffico medio',
			distribution_users_dow: 'Distribuzione settimanale',
			distribution_users_type: 'Tipologia di autenticazione',
			minutes_abbrev: 'min.',
			hours_abbrev: 'ore',
			user_new: 'Nuovi utenti',
			user_return: 'Utenti di ritorno',
			traffic_download: 'Traffico in Download',
			traffic_upload: 'Traffico in Upload',
		},
		troubleshooting: {
			title: 'Troubleshooting',
			logs: {
				title: 'Logs',
				table: {
					timestamp: 'Timestamp',
					mac_address: 'Mac Address',
					username: 'Username',
					result: 'Risultato',
					reason: 'Motivo',
					message: 'Messaggio',
					edit: 'Modifica',
				},
				noLocationSelected: 'Seleziona una location per visualizzare i logs',
			},
			sessions: {
				title: 'Sessions',
				table: {
					session_id: 'ID Sessione',
					location_id: 'ID Location',
					start_time: 'Inizio',
					end_time: 'Fine',
					duration: 'Durata',
					mac_address: 'Mac Address',
					ip: 'Indirizzo IP',
					username: 'Username',
					edit: 'Modifica',
					view: 'Vedi',
				},
				noLocationSelected:
					'Seleziona una location per visualizzare le sessioni',
			},
			events: {
				title: 'Event Stats',
				table: {
					timestamp: 'Timestamp',
					location_id: 'ID Location',
					mac_address: 'Mac Address',
					ip: 'Indirizzo IP',
				},
			},
		},
		sessionspage: {
			title: 'Dettagli del Profilo',
		},

		segments: {
			title: 'Segments',
		},
		realtime: {
			title: 'Real-Time',
			device: 'Dispositivi',
			users: 'Utenti',
			device_txt: 'Numero totale device',
			users_txt: 'Numero totale utenti',
			connectionsPerMinute: 'Numero delle conessioni per minuto',
		},
		users: {
			title: 'Utenti registrati al servizio',
		},
		traffic: {
			title: 'Traffico',
		},
		cashback: {
			title: 'Cashback',
			period: 'Tempo',
			message: 'Calcolo del tuo Cashback',
			error: {
				location_id: 'Devi selezionare una location',
			},
		},
		passpoint: {
			invitations: {
				create: 'Crea Invito',
			},
		},
		roaming: {
			title: 'Roaming',
		},
		location_group: {
			title: 'Location Group',
			create: 'Crea Location Group',
		},
		general: {
			user: 'Utente',
			fromWeek: 'Dalla settimana',
			untilWeek: 'Alla settimana',
			fromMonth: 'Dal mese',
			untilMonth: 'Al mese',
			fromYear: "Dall'anno",
			untilYear: "All' anno",
			fromDay: 'Dal giorno',
			toDay: 'Al giorno',
			error: {
				locationGroup: 'Location Group inesistente',
				location: 'Location inesistente',
			},
			selectAll: 'Tutte le locations',
			no: 'No',
			yes: 'Si',
		},
		invitation: {
			title: 'Passpoint Inviti',
			details: 'Dettaglio',
			create: 'Crea Invito',
		},
		trend: {
			title: 'Trend',
			sub_title: 'Confronto del numero di sessioni su due periodi temporali',
			select_period: 'Seleziona il periodo',
			dayInfo: 'Mostra le sessioni del giorno selezionato',
			weekInfo:
				'Mette a confronto la settimana selezionata con quella precedente',
			monthInfo:
				"Mette a confronto il mese selezionato con lo stesso mese dell'anno precedente",
			yearInfo: "Mette a confronto l'anno selezionato con l'anno precedente",
			reference_period: 'Periodo di riferimento ',
			reference_period_1: 'Periodo di riferimento 1',
			reference_period_2: 'Periodo di riferimento 2',
			from: 'Da',
			to: 'A',
			time_trends: 'Andamenti temporali',
			year: 'Anno',
			errorDateGranularity: 'Errore: la data non risulta essere valida',
		},
		account: {
			title: 'Dashboard accounts',
			create: 'Crea account',
		},
		god_user: {
			title: 'Dashboard God',
			create: 'Crea God',
		},
		sessions: {
			title: 'Sessioni',
			hoursSessionsDistribution: 'Distribuzione giornaliera',
			daySessionsDistribution: 'Distribuzione settimanale',
			weekSessionsDistribution: 'Distribuzione oraria giornaliera',
			sessionsTrend: 'Andamento temporale',
			session_number: 'Numero sessioni',
		},
		graph: {
			hourUsersDistribution: 'Distribuzione giornaliera',
			dayUsersDistribution: 'Distribuzione settimanale',
			weekUsersDistribution: 'Distribuzione oraria giornaliera',
			newReturnUsersDistribution: 'Andamento temporale',

			hourTrafficDistribution: 'Distribuzione giornaliera',
			dayTrafficDistribution: 'Distribuzione settimanale',
			weekTrafficDistributionUpload: 'Distribuzione oraria giornaliera Upload',
			weekTrafficDistributionDwonload:
				'Distribuzione oraria giornaliera Download',
			trafficTrend: 'Andamento temporale',

			total: 'Totale',
			peak_positive: 'Picco positivo',
			peak_negative: 'Picco negativo',
			average: 'Media',
		},
		select: {
			day: 'Giorno',
			week: 'Settimana',
			month: 'Mese',
			year: 'Anno',
			custom_date: 'Data',
		},
		location: {
			title: 'Service Monitoring',
			total: 'Locations',
			never_seen: 'Funzionanti',
			silent: 'Silenti',
			active: 'In attivazione',
		},
		table: {
			id: 'ID',
			name: 'Nome',
			ip_address: 'Indirizzo IP',
			last_connection: 'Ultima connessione',
			session_number: 'Numero sessioni',
			status: 'Stato',
			active: 'Traffico avvenuto negli ultimi 3 giorni',
			never_seens: 'Traffico mai avvenuto',
			silent: 'Traffico mai avvenuto negli ultimi 3 giorni',
			allStatus: 'Tutto',
			search: 'Cerca',
			reset: 'Reset',
			rank: 'Posizione',
			value: 'Valore',
			noData: 'Nessun dato',
			enable_monitoring: 'Abilita il monitoraggio',
			enable_notify: 'Notifiche',
			sponsor_email: 'Sponsor Email',
			first_name: 'Nome',
			last_name: 'Cognome',
			email: 'Email',
			identity_email: 'Email identità',
			phone_number: 'Numero di telefono',
			marketing_consent: 'Marketing',
			profile_consents: 'Profilazione',
			strategy: 'Metodo di autenticazione',
			filter_strategy: 'Filtro',
			all_strategies: 'Tutti',
			passpoint_only: 'Solo Passpoint',
			captive_only: 'Solo Captive portal',
			verified: 'Verificato',
			last_update: 'Ultimo aggiornamento',
			show_sessions: 'Dettagli',
			actions: 'Azioni',
			password: 'Password',
			searchTooltip: 'Cerca per id, username, nome, cognome, cellulare',
			location_id: 'Nome Location',
			location: 'Location',
			mac_address: 'Mac Address',
			download: 'Download',
			upload: 'Upload',
			duration: 'Durata',
			start: 'Inizio',
			stop: 'Fine',

			username: `Username`,
			role: 'Ruolo',
			brand: 'Brand',
			visible_sections: 'Sezioni visibili',
			locations: 'Locations',

			option: 'Opzioni',
			registered_at: 'Registrato il',

			channel: 'Canale',
			created_at: 'Creato il',
			last_login: 'Ultimo accesso',
			since: 'Valido dal',
			until: 'Valido sino al',
			os_version: 'Versione OS',
			mac: 'Mac',
			expiration: 'Scadenza',
			valid: 'Valido',
			disabled: 'Disabilitato',
			notActiveYet: 'Non ancora attivo',
			expired: 'Scaduto',
			notValid: 'Non valido',

			scope: 'Ambito',
			enabled: 'Abilitato',
			description: 'Descrizione',
			tenant: 'Tenant',
			hidden_sections: 'Sezioni nascoste',

			metadata: 'Metadati',

			permissions_group: 'Gruppo permessi',
			permissions: 'Permessi',
			locations_group: 'Gruppo Locations',

			selectScope: 'Seleziona Ambito',
			selectBrand: 'Seleziona Brand',
			selectHiddenSections: 'Seleziona Sezioni Nascoste',

			max_devices: 'Device massimi consentiti',
			notes: 'Note',
			policy: 'Policy',
			sent_at: 'Data invio',
			type: 'Tipo',
			user_type: 'Tipologia Utente',
			valid_from: 'Profilo valido da',
			valid_to: 'Profilo valido a',
			expiration_hours: 'Ore di validità invito',

			session_id: 'ID Sessione',
			profile_id: 'ID Profilo',

			tot_locations: 'N. Locations',
		},
		ranking: {
			title: 'Ranking',
			top_ten_users: 'Prime 10 Locations per numero di utenti',
			top_ten_connections: 'Prime 10 Locations per numero di connessioni',
			ranking_users: 'Ranking Utenti',
			ranking_connections: 'Ranking Sessioni',
			yesterday: 'IERI',
			last_week: 'ULTIMA SETTIMANA',
			last_month: 'ULTIMO MESE',
			last_year: 'ULTIMO ANNO',
			showAll: 'Mostra tutte',
			weekInfo:
				"Mette a confronto il primo giorno della settimana con l'ultimo",
			monthInfo:
				"Mette a confronto il primo giorno del mese con l'ultimo giorno del mese",
			custom_range: "Mette a confronto l'intervallo delle due date selezionate",
		},
		modal: {
			location_settings: "Opzioni di settaggio sull'intero Location Group",
			silent_threshold: 'Soglia di Location silenti',
			list_address_email: 'Lista degli indirizzi email',
			solved_threshold: 'Soglia di Location risolte',
			notifications_enabled: 'Notifiche abilitate',
			monitoring_enabled: 'Monitoraggio abilitato',
			location_settings_alert: 'Alert Locations',
			disable: 'Disabilita Profilo',
			warning: 'Attenzione',
			v_old_dashboard_button: 'Vai alla vecchia versione',
			v_old_dashboard_title:
				'Passaggio alla precedente versione di MyGuglielmo.',
			v_old_dashboard_text: `Stai per essere reindirizzato alla precedente versione della dashboard MyGuglielmo<br/> Vuoi procedere?`,
			info_alert_location:
				"Sembra che la tua utenza non abbia i permessi per poter visualizzare le locations. Contatta l'amministratore per ottenere i permessi necessari",
			popconfirmtitle: `Attenzione! L'operazione disabilita TUTTI i profili associati al device. Sei sicuro di voler procedere?`,
			success: {
				save_settings: 'Settaggi salvati con successo',
				change_status: 'Stato cambiato con successo',
				disable_profile: 'Profilo disabilitato con successo',
				delete_invitation: 'Invito eliminato con successo',
				send_mail_invitation: 'Email inviata con successo',
				bulk_invitation: 'Inviti inviati con successo',
			},
			error: {
				save_settings: 'Errore nel salvataggio dei settaggi',
				change_status: 'Errore nel cambiamento dello stato',
				disable_profile: 'Errore nella disabilitazione del profilo',
				delete_invitation: "Errore nell'eliminazione dell'invito",
				send_mail_invitation: "Errore nell'invio dell'email",
				bulk_invitation: "Errore nell'invio degli inviti",
			},
			changeUntil: 'Cambia la data di scadenza',
			create: 'Crea',
			edit: 'Modifica',
			delete: 'Elimina',
		},
		alert: {
			success: {
				bulk_invitation: 'Inviti inviati con successo',
				save_settings: 'Settaggi salvati con successo',
				change_status: 'Stato cambiato con successo',
				accountUpdated: 'Account aggiornato con successo',
				accountCreated: 'Account creato con successo',
				accountDeleted: 'Account eliminato con successo',
				untilDateUpdate: 'Data di scadenza aggiornata con successo',
				locationGroupCreated: 'Location Group creato con successo',
				locationGroupUpdated: 'Location Group aggiornato con successo',
				locationGroupDeleted: 'Location Group eliminato con successo',
				godUserCreated: 'God User creato con successo',
				godUserDeleted: 'God User eliminato con successo',
				canCSVExported: 'È possibile scaricare il file',
				invitations: {
					create: 'Invito creato con successo',
					delete: 'Invito eliminato con successo',
					update: 'Invito aggiornato con successo',
					send: 'Invito inviato con successo',
				},
			},
			error: {
				bulk_invitation: "Errore nell'invio degli inviti",
				save_settings: 'Errore nel salvataggio dei settaggi',
				change_status: 'Errore nel cambiamento dello stato',
				accountUpdated: "Errore nell'aggiornamento dell'account",
				accountCreated: "Errore nella creazione dell'account",
				accountDeleted: "Errore nell'eliminazione dell'account",
				requiredFieldAlert: 'Compila i campi obbligatori',
				requiredField: 'Campo obbligatorio',
				emailNotValid: 'Email non valida',
				untilDateUpdate: "Errore nell'aggiornamento della data di scadenza",
				locationGroupCreated: 'Errore nella creazione del Location Group',
				locationGroupUpdated: "Errore nell'aggiornamento del Location Group",
				locationGroupDeleted: "Errore nell'eliminazione del Location Group",
				godUserCreated: 'Errore nella creazione del God User',
				godUserDeleted: "Errore nell'eliminazione del God User",
				invitations: {
					create: "Errore nella creazione dell'invito",
					delete: "Errore nell'eliminazione dell'invito",
					update: "Errore nell'aggiornamento dell'invito",
					send: "Errore nell'invio dell'invito",
					list: "Errore nella visualizzazione dell'elenco degli inviti",
				},
			},
			info: {
				invitations: {
					list: 'Non son presenti ancora inviti Passpoint',
				},
			},
			warning: {
				canCSVExported: 'Non risultano dati da esportare',
			},
		},
		time_range: {
			LAST_7_DAYS: 'Ultimi 7 giorni',
			LAST_30_DAYS: 'Ultimi 30 giorni',
			LAST_180_DAYS: 'Ultimi 180 giorni',
			LAST_365_DAYS: 'Ultimi 365 giorni',
			WEEK: 'Seleziona la settimana',
			MONTH: 'Seleziona il mese',
			QUARTER: 'Seleziona il trimestre',
		},
		tooltip: {
			cashback:
				'Il Cashback è calcolato in base al traffico totale effettuato nella tua location',
			overview_device: 'Numero totale di device connessi',
			overview_usage: 'Numero totale di ore di connessione',
			overview_user:
				'Numero totale di utenti unici senza distinzione tra quelli nuovi e di ritorno',
			// overview_total_traffic_dow:'Traffico totale in download e upload',
			overview_total_traffic_dow: 'Traffico medio giornaliero per dispositivo',
			overview_traffic_upload_download: 'Traffico totale in download e upload',
			overview_average_traffic_upload_download:
				'Traffico medio per giorno della settimana',
			// overview_distribution_users_dow:'Traffico medio per ora del giorno e giorno della settimana',
			overview_distribution_users_dow:
				'Distribuzione traffico totale giornaliero per dispositivo',
			overview_users_type:
				'Distribuzione della tipologia di autenticazione utilizzata per accedera al servizio',
			realtime_connectionsPerMinute:
				'Andamento delle sessioni negli ultimi 15 minuti',
			realtime_device_txt:
				'Numero totale di device attualmente connessi al servizio',
			realtime_users_txt:
				'Numero totale di utenti attualmente connessi al servizio',
			users_hourUsersDistribution:
				'Distribuzione media degli utenti per ora del giorno',
			users_dayUsersDistribution:
				'Distribuzione media degli utenti per giorno della settimana',
			users_weekUsersDistribution:
				'Distribuzione media degli utenti per giorno della settimana e per ora del giorno',
			users_newReturnUsersDistribution:
				'Distribuzione temporale degli utenti nuovi e di ritorno',
			sessions_hoursSessionsDistribution:
				'Distribuzione media delle sessioni per ora del giorno',
			sessions_daySessionsDistribution:
				'Distribuzione media delle sessioni per giorno della settimana',
			sessions_weekSessionsDistribution:
				'Distribuzione media delle sessioni per giorno della settimana e per ora del giorno',
			sessions_sessionsTrend: 'Distribuzione temporale delle sessioni',
			traffic_hourTrafficDistribution:
				'Distribuzione media del traffico per ora del giorno',
			traffic_dayTrafficDistribution:
				'Distribuzione media del traffico per giorno della settimana',
			traffic_weekTrafficDistributionUpload:
				'Distribuzione media del traffico in upload per giorno della settimana e per ora del giorno',
			traffic_weekTrafficDistributionDownload:
				'Distribuzione media del traffico in download per giorno della settimana e per ora del giorno',
			traffic_trafficTrend: 'Andamento temporale del traffico',
			trend_weekInfo:
				'Mette a confronto le sessioni della settimana selezionata con quella precedente',
			trend_monthInfo:
				"Mette a confronto le sessioni del mese selezionato con lo stesso mese dell'anno precedente",
			trend_yearInfo:
				"Mette a confronto le sessioni dell'anno selezionato con l'anno precedente",
			monitoring_total: 'Totale locations censite a sistema',
			monitoring_active:
				'Totale locations censite a sistema e che hanno fatto almeno un login negli ultimi x giorni (x è il numero di giorni impostati come soglia)',
			monitoring_silent:
				'Totale locations censite a sistema e che non fanno traffico da almeno x giorni (x è il numero di giorni impostati come soglia)',
			monitoring_inActiv:
				'Totale locations censite a sistema e che non hanno mai fatto nessuna connessione',
			clients_total:
				'Totale utenti che hanno utilizzato il servizio comprensivo degli utenti che hanno provato ad accedere senza convalidare i propri dati utilizzati in fase di login  ( mail o numero di telefono)',
			clients_verified:
				'Totale utenti che hanno completato la procedura di registrazione',
			clients_mktg: 'Totale utenti che hanno dato il consenso marketing',
			clients_prof:
				'Totale utenti che hanno dato il consenso alla profilazione',
			show: 'Mostra',
		},
		client: {
			totals: 'Totale',
			verified: 'Verificati',
			marketing_consent: 'Contattabili',
			profile_consent: 'Consenso profilazione',
		},
		client_sessions: {
			title: 'Sessioni Client',
		},
		header: {
			period: 'Periodo',
			locationGroup: 'Gruppo',
			locationId: 'Location',
			last_15_minutes: 'Ultimi 15 minuti',
			allLocations: 'Tutte le locations',
			goBackUserList: 'Ritorna alla lista utenti',
			goBack: 'Torna indietro',
		},
		component: {
			button: {
				addLocation: 'Aggiungi Location',
				delete: 'Elimina',
				save: 'Salva',
				cancel: 'Annulla',
			},
			select: {
				locationGroup: 'Locations group',
				location: 'Locations',
			},
		},
	},
};
